import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { units, Typography } from '@hbf/dsl';
import { useIntl } from 'ha/i18n';
import { UserEntity } from 'ha/types/UserEntity';

interface Props {
  user: UserEntity;
}

const useStyles = makeStyles()(() => ({
  root: {
    padding: units.yx(0, 1),
  },
  section: {
    marginBottom: units.rem(1),
  },
}));

const UserCardContactDetails: React.FC<Props> = ({
  user: { phone, email },
}) => {
  const { T } = useIntl();
  const hasPhone = Boolean(phone);
  const hasEmail = Boolean(email);

  const { classes, cx } = useStyles();

  return (
    <div className={classes.root} data-test-locator="User Card Contact Details">
      {hasPhone && (
        <Typography.Caption
          className={cx({
            [classes.section]: hasEmail,
          })}
        >
          <strong>{T('Phone number')}</strong>
          <br />
          {phone}
        </Typography.Caption>
      )}
      {hasEmail && (
        <Typography.Caption>
          <strong>{T('Email')}</strong>
          <br />
          {email}
        </Typography.Caption>
      )}
    </div>
  );
};

export { UserCardContactDetails };
